import React, { useEffect, useState, useContext } from 'react';
import { useAuth } from '../../Contexts/AuthContext';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useAccounts } from '../../Contexts/Context_Accounts';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import Tab_ScheduleManagement_Calendar from './Tab_ScheduleManagement_Calendar';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';
import { Context_UI } from '../../Contexts/Context_UI';
import { useTemplating } from '../../Contexts/Context_Templating';
import UI_Divider from '../ERUMAUI/UI_Divider';
import { useNavigate } from 'react-router-dom';

export default function Panel_ScheduleManagement_Right() {
    const UI = useContext(Context_UI);
    const { Account, Loading, Logout } = useAuth();
    const { Schedules, Time_Range_Parse, Status_Parse, Schedule_Information, Schedule_Display, Reject_As, Approve_As, Time_Parse } = useScheduleManagement();
    const { Template_List } = useTemplating();
    const { Room_Get_Address } = useMapRenderer();
    const { Panel_Right_State, Panel_Toggle } = useStatus();
    const Navigate = useNavigate(); 
    if (Loading) {
        return null;
    }

    const Handle_Click = async (ID) => {
        // console.log(Panel_Right_State);
        await Schedule_Display(ID);
        if (Panel_Right_State == "Collapsed") {
            Panel_Toggle("Right");
        }
    }

    const User_canManage = Account?.Access.Reservation.Edit || Account?.Access.Reservation.Approve.Initial || Account?.Access.Reservation.Approve.Final;


    return (
        <>
            {Schedule_Information ?
                <div style={{ display: "grid", gridTemplateRows: "1fr auto", gap: "10px", width: "100%" }}>
                    <div style={{ overflowY: "auto" }}>
                        {Schedule_Information.Requester.RequesterID == Account._id || User_canManage ? 
                            // <h1 className='General_Title' onClick={() => UI.Subwindows_Open('Window_ScheduleManagement_Document')}>
                            //     {Schedule_Information?.Name}
                            // </h1>
                            <h1 className='General_Title' onClick={() => Navigate('/schedules/manage')}>
                                {Schedule_Information?.Name}
                            </h1>
                            :
                            <h1 className='General_Title'>
                                {Schedule_Information?.Name}
                            </h1>
                        }

                        <UI_Divider/>
                        
                        <UI_ChipGroup Items={Status_Parse(Schedule_Information)} />
                        <UI_Divider />
                        {/* <p>
                            {Status_Parse(Schedule_Information)}
                        </p> */}
                        <UI_Card Type="Panel_Info"
                            Text="Time"
                            Figure={Time_Range_Parse(Schedule_Information?.Time.Start, Schedule_Information?.Time.End, "Time")} />
                        <UI_Card Type="Panel_Info"
                            Text="Date"
                            Figure={Time_Parse(Schedule_Information?.Time.Start, "Date")} />
                        <UI_Card Type="Panel_Info"
                            Text="Location"
                            Figure={Room_Get_Address(Schedule_Information?.RoomID)} />
                        
                        <UI_Card Type="Panel_Info"
                            Text="Request type"
                            Figure={Schedule_Information?.Activity.Type} />
                        <UI_Card Type="Panel_Info"
                            Text="Requester name"
                            Figure={Schedule_Information?.Requester.Name} />
                        {Schedule_Information?.Description ?
                            <UI_Card Type="Panel_Info"
                                Text="Description"
                                Figure={Schedule_Information?.Description} />
                            :
                            ""
                        }
                        
                        {/* <UI_Card Type="Panel_Info"
                            Text="Requester email"
                            Figure={Schedule_Information?.Requester.Email} /> */}
                        {/* <UI_Card Type="Panel_Info"
                            Text="Number of participants"
                            Figure={`${Schedule_Information?.Activity.Attendees.Names.length} ${Schedule_Information?.Activity.Attendees.Names.length > 1 ? 'participants' : 'participant'}`} /> */}
                        {/* <UI_Card Type="Panel_Info"
                            Text="Additional remarks"
                            Figure={Schedule_Information?.Remarks} /> */}
                        
                    </div>
                    {/* <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <UI_LinearGroup Fill Gap="Gap">
                            {Account.Access.Report.ReservationSlip ?
                                <UI_Button
                                    Text="Print"
                                    Icon={<UI_Icon Name="Print" />}
                                    Icon_Position="Left"
                                />
                                :
                                ""
                            }
                        </UI_LinearGroup>
                        
                        
                    </div> */}
                </div>
                :
                <>
                    <p className='General_Paragraph'>
                        Select a schedule on the left to view its information here.
                    </p>
                </>
            }

        </>
    );
}
